import { SVGProps } from 'react';

const InfoIcon = ({
  height = '16px',
  width = '16px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 17.5 17.5'
    {...props}
  >
    <g id='ic-actions-add' transform='translate(-1.25 -1.25)'>
      <circle
        id='Ellipse_1'
        data-name='Ellipse 1'
        cx='8'
        cy='8'
        r='8'
        transform='translate(2 2)'
        fill='none'
        stroke='#99a3a2'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth='1.5'
      />
      <line
        id='Line_10'
        data-name='Line 10'
        y1='4.512'
        transform='translate(10.167 8.812)'
        fill='none'
        stroke='#99a3a2'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth='1.5'
      />
      <line
        id='Line_572'
        data-name='Line 572'
        transform='translate(10.152 6.5)'
        fill='none'
        stroke='#99a3a2'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth='2'
      />
      <line
        id='Line_444'
        data-name='Line 444'
        transform='translate(10.167 6.408)'
        fill='none'
        stroke='#99a3a2'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth='2'
      />
    </g>
  </svg>
);

export default InfoIcon;
